import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading: boolean = false;
  private _label: string = '';

  constructor() {}

  start() {
    setTimeout(() => {
      this.loading = true;
    }, 0);
  }

  stop() {
    setTimeout(() => {
      this.loading = false;
    }, 0);
  }

  setLoading(loading: boolean) {
    setTimeout(() => {
      this.loading = loading;
    }, 0);
  }

  getLoading(): boolean {
    return this.loading;
  }

  public get label(): string {
    return this._label;
  }
  public set label(value: string) {
    this._label = value;
  }
}
